import React, { useMemo, useState } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";

export default function IntegrationAgentsTable({ data, rows }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page") ?? 1) - 1,
    pageSize: Number(searchParams.get("page_size") ?? 50),
  });

  const handlePaginationModelChange = paginationModel => {
    searchParams.set("page", paginationModel.page + 1);
    searchParams.set("page_size", paginationModel.pageSize);

    setSearchParams(searchParams);
    setPaginationModel(paginationModel);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Filial",
        field: "subsidiary",
        flex: 1,
        renderCell: params => params.row?.RFR_FILIAL,
      },
      {
        headerName: "Código",
        field: "integrationCode",
        flex: 1,
        renderCell: params => params.row?.RFR_AGENTE,
      },
      {
        headerName: "Nome",
        field: "integrationName",
        flex: 1,
        renderCell: params => params.row?.RFR_NOME,
      },
      {
        headerName: "CNPJ",
        field: "integrationCNPJ",
        flex: 1,
        renderCell: params => params.row?.RFR_CNPJ,
      },
      // {
      //   field: "actions",
      //   type: "actions",
      //   headerName: "Ações",
      //   width: 70,
      //   getActions: params => [
      //     <GridActionsCellItem
      //       onClick={() => {
      //         searchParams.set("department_id", params.row.QB_DEPTO);
      //         setSearchParams(searchParams);
      //       }}
      //       label="Editar"
      //       showInMenu
      //     />,
      //   ],
      // },
    ],
    [searchParams, setSearchParams],
  );

  return (
    <DataGrid
      rows={data}
      columns={columns}
      getRowId={row => row.R_E_C_N_O_}
      sx={{ flex: 1, border: "none" }}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      rowCount={rows}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
}
